module.exports = __webpack_public_path__ + "static/media/fiscal02.bd4dda93.jpeg";